// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__AgG02","error":"Alert_error__2r-Yp","alertContent":"Alert_alertContent__2TFLE","title":"Alert_title__1Fl4r","text":"Alert_text__YMNW8"};